<div class="header_search">
  <div class="title-page">
    <h3>{{infoProjeto.menu.produto.tipo_cadastro_formatted}}</h3>
  </div>
  <div class="content_search">
    <div class="new-project">
      <a class="btn btn-primary" type="btn" routerLink="adicionar">Novo</a>
    </div>
  </div>
</div>


<div class="system-table table-container">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th>{{infoProjeto.menu.produto.tipo_cadastro_formatted}}</th>
          <th class="text-center">Meta</th>
          <th class="text-center">Custo Estimado</th>
          <th class="text-center">Status</th>
          <th class="text-center">% de Execução</th>
          <th class="text-center">Data de Conclusão</th>
          <th class="text-center">% Previsto de Execução</th>
          <th class="text-center">Data Prevista de Conclusão</th>
          <th class="text-center btn-icon-td">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of produtoPesquisa">
          <tr>
            <td class="title"><span class="title-span">{{item?.description}}</span></td>
            <td class="text-center">{{item?.ds_goal}}</td>
            <td class="text-center">{{item?.value}}</td>
            <td class="status">
              <div *ngIf="item?.status">
                <span [innerHTML]="item?.status"></span>
              </div>
            </td>
            <td class="text-center">{{item?.executed}}</td>
            <td class="text-center">{{item?.dt_foreseen_conclusion}}</td>
            <td class="text-center">{{item?.foreseen_executed}}</td>
            <td class="text-center">{{item?.bl_dt_foreseen_conclusion}}</td>
            <td>
              <div class="btn-icon">
                <a class="icon-table" [routerLink]="item?.id">
                  <img src="assets/images/svgs/editar1.svg" alt="Editar" tooltip="Editar" placement="bottom">
                </a>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="!produtoPesquisa?.length" class="border-b-radius">
          <td colspan="9" class="text-center">Nenhum {{infoProjeto.menu.produto.tipo_cadastro_formatted}} Cadastrado.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>